import template from './adpComponentSection.html';
import controller from './adpComponentSection.controller';
import './adpComponentSection.less';

let adpComponentSectionComponent = {
  restrict: 'E',
  bindings: {},
  template,
  transclude: true,
  controller
};

export default adpComponentSectionComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpComponentSection/adpComponentSection.component.js